angular.module('aprima-core-ui')
.directive('apDragDrop', [function () {
    'use strict';

    return {
        scope: {
            index: '=',
            startIndex: '&',
             dropIndex: '&',        
        },        
        link: function (scope,element) {
            
            var sIndex = -1;
            var dindex = -1;
            var i = element.find('[id*="ph"]');
            

            i[0].draggable = true;

            i[0].addEventListener('dragstart', function ondragstart() {
                sIndex = scope.index;
                scope.startIndex({ssIndex:sIndex});           
                 });
                 
            i[0].addEventListener('drop', function ondrop(evt) {
                evt.preventDefault();
                dindex = scope.index;                
                scope.dropIndex({ddIndex:dindex});              
            });

            i[0].addEventListener('dragover', function ondrgaover(evt) { 
                    evt.preventDefault(); });                
        }
    };

}]);